import createTracker from './create-tracker';
import { config } from './create-tracker';
import initTracker from './initTracker';

const { $$tracker, stReportSdk, getDiffRouteTime, report, trackPageLoad, trackPageLeave } = initTracker(createTracker, config, {}, true);

export { $$tracker, stReportSdk, getDiffRouteTime, report, trackPageLoad, trackPageLeave };
